export interface IStepEditableArgs {
  isAdmin: boolean;
  currentStep: { editable?: boolean } | null | undefined;
  status?: string | null;
}

/** @registry The single rule deciding whether a workflow record's data inputs are editable: admins always, otherwise not voided and the step's `editable` flag is not false. */
export const isStepEditable = ({
  isAdmin,
  currentStep,
  status,
}: IStepEditableArgs): boolean =>
  isAdmin || (status !== 'Voided' && currentStep?.editable !== false);
